import styles from './style.module.scss'

type Props = {
  isMenuOpen: boolean
  handleClick: () => void
}

export const MenuButton = ({ isMenuOpen, handleClick }: Props) => {
  return (
    <div
      className={styles.container + ' ' + (isMenuOpen ? styles.openMenu : '')}
      onClick={handleClick}
    >
      <span className={styles.meat + ' ' + styles.meat1} />
      <span className={styles.meat + ' ' + styles.meat2} />
      <span className={styles.meat + ' ' + styles.meat3} />
    </div>
  )
}

export default MenuButton
